module.exports = __webpack_public_path__ + "static/media/badge_ptrnA.018dc510.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/badge_ptrnA.png
// module id = 1619
// module chunks = 1